import { z } from 'zod';
// ── analytics (FR-ADM-70/71) ──────────────────────────────────────────────
export const DashboardView = z.object({
    product: z.object({
        members: z.number().int(),
        activated7d: z.number().int(),
        postsThisWeek: z.number().int(),
        paidMembers: z.number().int(),
        donationSuccessRate: z.number(),
    }),
    ops: z.object({
        openReports: z.number().int(),
        slaBreached: z.number().int(),
        openTickets: z.number().int(),
        pendingUpgrades: z.number().int(),
        paymentSuccessRate: z.number(),
    }),
});
//# sourceMappingURL=schemas.js.map